const categories = [
  {
    id: "PRG",
    name: "Programming",
    content: [
      {
        _id: "PRG",
        id: "PRG01",
        name: "Programming",
        category: "Beginner",
        learn: "Basics of React Hooks",
        implement: "100+ programming exercises",
        currLink: "",
        paid: false,
      },
      {
        _id: "PRG",
        id: "PRG02",
        name: "Programming",
        category: "Intermediate",
        learn: "Frontend Web Development",
        implement: "Build Top 5 clone projects",
        currLink: "",
        paid: false,
      },
      {
        _id: "PRG",
        id: "PRG03",
        name: "Programming",
        category: "Advanced",
        learn: "Full Stack Web Development",
        implement: "Build 5+ MERN projects",
        currLink: "",
        paid: true,
      },
    ],
  },
  {
    id: "DM",
    name: "Digital Marketing",
    content: [
      {
        _id: "DM",
        id: "DM01",
        category: "Beginner",
        name: "Digital Marketing",
        learn: "Basic of Digital Marketing",
        implement: "On Page and Off Page SEO",
        currLink: "",
        paid: false,
      },
      {
        _id: "DM",
        id: "DM02",
        category: "Intermediate",
        name: "Digital Marketing",
        learn: "Ads & Social Media Integration",
        implement: "Creating backlinks",
        currLink: "",
        paid: false,
      },
      {
        _id: "DM",
        id: "DM03",
        category: "Advanced",
        name: "Digital Marketing",
        learn: "Creating Website using WIX & WordPress",
        implement: "Plugins and Hosting",
        currLink: "",
        paid: true,
      },
    ],
  },
  {
    name: "Soft Skills",
    content: [
      {
        _id: "SS",
        id: "SS01",
        category: "Beginner",
        name: "Soft Skills",
        learn: "Communication Skills",
        implement: "Hands on 1-1 interaction with expert",
        currLink: "",
        paid: false,
      },
      {
        _id: "SS",
        id: "SS02",
        category: "Intermediate",
        name: "Soft Skills",
        learn: "Business Writing & Group Discussion",
        implement: "Business writing for your startup ideas",
        currLink: "",
        paid: false,
      },
      {
        _id: "SS",
        id: "SS03",
        category: "Advanced",
        name: "Soft Skills",
        learn: "Pro-eminent and proficiency in soft skills",
        implement: "Live interation with experts",
        currLink: "",
        paid: true,
      },
    ],
  },
];

export default categories;
